import _typeof from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import { computed, defineComponent, watch } from "vue";
import { useI18n } from "vue-i18n";
import { SingleCategoryEvent } from "@/test/scenarios/booking";
import BookingModule from "@/store/modules/booking";
import { Currencies } from "@/constants/currency";
import { deleteUncompletedBookingAccountings, applyPayment, createRefundPSSAccounting } from "@/utils/vue-helpers/accounting";
import { SvgIcon } from "@/components/index";
import editPenSvg from "@/assets/images/svg/edit-pen.svg";
import { AccountingState, PaymentCard, PaymentMethods, PaymentTool, TransactionTypes } from "@/types/db/accounting";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { DiscountTypes } from "@/interfaces/store/IBooking";
import { BookingStep } from "@/constants/booking";
import { PaymentMethodTypeToPaymentTool, PaymentMethodTypes } from "@/types/db/pos-config";
import POSConfigModule from "@/store/modules/pos-config";
import { canCompleteOrder, toLocalAccountings } from "@/utils/vue-helpers/booking";
import Discount from "./Discount.vue";
import Promocode from "./Promocode.vue";
import { syncAvailabilities } from "@/db/product-slot-booking";
import { formatCurrency } from "@/utils/helpers/currency";
import { getLocale } from "@/lang";
import { cloneDeep } from "lodash";
import { LogService } from "@/services/logging";
import { getDefaultPaymentTool, PaymentMethodTypeToTranslatedString } from "@/utils/vue-helpers/pos-config";
import dayjs from "dayjs";
import { BookingStatus, RefundStatus } from "@/types/db/product-slot-state";
import CashFloatModule from "@/store/modules/cash-float";
import { ref } from "vue";
import { PaymentToolMethod } from "@/types/db/accounting";
import PaymentService from "@/services/payment-service";
import { bookingTotalIgnoringDiscounts, discountTotal, isBookingFree, restToPay } from "@/utils/vue-helpers/new-accountings";
import { hasMultiCurrenciesEnabled } from "@/utils/vue-helpers/cash-float";
import { roundToNearestMultipleOf5, sumArray } from "@/utils/helpers/common";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
import PromocodeCampaigns from "./PromocodeCampaigns.vue";
import UserModule from "@/store/modules/user";
import NotificationService from "@/services/notification.service";
import AppModule from "@/store/modules/app";
import { getAccountingWithUUID, getBookingAccountings, getBookingWithUUID } from "@/api/gql/product-slot-boooking";
import { postPOSRefund } from "@/api/payment";
import Timeout from "await-timeout";
import { ACCErrors } from "@/constants/errors/accounting";
export default defineComponent({
  name: "app",
  components: {
    Discount: Discount,
    SvgIcon: SvgIcon,
    Promocode: Promocode,
    PromocodeCampaigns: PromocodeCampaigns
  },
  setup: function setup() {
    var _BookingModule$select;

    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var iconStyle = "filter: contrast(170%) invert(0%); padding-left: 10px;";
    var iconContent = editPenSvg;
    var iconAlt = "edit";
    var posConfig = POSConfigModule.selectedConfig;
    var paymentConfig = (posConfig === null || posConfig === void 0 ? void 0 : posConfig.paymentConfig) || {
      cash: {
        used: true,
        acceptedCurrencies: ["CHF"]
      },
      cardAuto: {
        used: false,
        processor: "ADYEN"
      },
      cardManual: {
        used: true,
        paymentMethods: ["VISA", "TWINT"]
      },
      invoice: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      toBeInvoiced: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      bankTransfer: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      cheque: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      chequeVacances: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      chequeCulture: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      passCulture: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      chorus: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      CE: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      OCCYG: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      posReka: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      CFF: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      CGN: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      QOQA: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      DEINDEAL: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      REALDEAL: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      diverseVoucher: {
        used: false,
        acceptedStatuses: ["Pending", "Paid"]
      },
      terminal: ""
    };
    var IsEditOrder = computed(function () {
      return BookingModule.isEditOrderBooking;
    });
    var cashPaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.cash.used;
    });
    var bookingPaymentCurrency = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].currency;
    });
    var paymentCurrency = computed(function () {
      if (paymentTool.value === PaymentTool.Cash && selectedCashCurrency.value) {
        return selectedCashCurrency.value.label;
      }

      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].currency;
    });
    var cardAutoPaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.cardAuto.used;
    });
    var cardManualPaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.cardManual.used;
    });
    var bankTransferPaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.bankTransfer.used;
    });
    var InvoicePaymentMethod = computed(function () {
      return POSConfigModule.getPaymentConfig.invoice.used;
    });
    var ChequePaymentMethod = computed(function () {
      var _POSConfigModule$getP;

      return ((_POSConfigModule$getP = POSConfigModule.getPaymentConfig.cheque) === null || _POSConfigModule$getP === void 0 ? void 0 : _POSConfigModule$getP.used) && (POSConfigModule.getGroupCountryCode === "FR" || getLocale() === "fr");
    });
    var ChequeVacancesPaymentMethod = computed(function () {
      var _POSConfigModule$getP2;

      return ((_POSConfigModule$getP2 = POSConfigModule.getPaymentConfig.chequeVacances) === null || _POSConfigModule$getP2 === void 0 ? void 0 : _POSConfigModule$getP2.used) && (POSConfigModule.getGroupCountryCode === "FR" || getLocale() === "fr");
    });
    var CEPaymentMethod = computed(function () {
      var _POSConfigModule$getP3;

      return ((_POSConfigModule$getP3 = POSConfigModule.getPaymentConfig.CE) === null || _POSConfigModule$getP3 === void 0 ? void 0 : _POSConfigModule$getP3.used) && groupId.value && [19360, 16342, 16342].includes(groupId.value);
    });
    var OCCYGPaymentMethod = computed(function () {
      var _POSConfigModule$getP4;

      return ((_POSConfigModule$getP4 = POSConfigModule.getPaymentConfig.OCCYG) === null || _POSConfigModule$getP4 === void 0 ? void 0 : _POSConfigModule$getP4.used) && groupId.value && [19360, 16342, 16342].includes(groupId.value);
    });
    var isFree1 = computed(function () {
      // A booking is considered FREE if their tickets are free or is fully discounted
      return isBookingFree.value;
    });
    var isFullyPaidInPromocodeStep = computed(function () {
      // A booking that becomes fully paid in Promocode Step will have payment methods disabled
      return (BookingModule.bookingStep === BookingStep.Promocode || BookingModule.bookingStep === BookingStep.PromocodeCampaigns) && restToPay.value <= 0;
    });
    var isFullyPaidInDiscountStep = computed(function () {
      // A booking that becomes fully paid in Discount Step will have payment methods disabled
      return BookingModule.bookingStep === BookingStep.Discount && restToPay.value <= 0;
    });
    var step = computed(function () {
      return BookingModule.bookingStep;
    });
    var showDiscount = computed(function () {
      var hasDiscountRole = !UserModule.isSellerNoDiscount;
      return hasDiscountRole && (paymentConfig.cash.used || paymentConfig.cardAuto.used || paymentConfig.cardManual.used);
    });
    var groupId = computed(function () {
      return POSConfigModule.groupId;
    });
    var groupCurrencies = computed(function () {
      return POSConfigModule.groupCurrencies;
    });
    var currencies = computed(function () {
      var _CashFloatModule$cash;

      var currencies = [];
      var startAmounts = (_CashFloatModule$cash = CashFloatModule.cashFloat) === null || _CashFloatModule$cash === void 0 ? void 0 : _CashFloatModule$cash.startAmounts;

      var _loop = function _loop(currency) {
        var currencyInfo = groupCurrencies.value.find(function (c) {
          return c.label === currency;
        });

        if (currencyInfo) {
          currencies.push(currencyInfo);
        }
      };

      for (var currency in startAmounts) {
        _loop(currency);
      }

      return currencies;
    }); // for multi currency payments

    var selectedCashCurrency = computed(function () {
      return BookingModule.selectedCashCurrency;
    });
    var selectedCashCurrencyLabel = computed(function () {
      var _selectedCashCurrency;

      return ((_selectedCashCurrency = selectedCashCurrency.value) === null || _selectedCashCurrency === void 0 ? void 0 : _selectedCashCurrency.label) || "";
    });
    var groupCurrency = computed(function () {
      var currency = currencies.value.find(function (c) {
        return c.isDefault === 1;
      }) || currencies.value[0];
      return currency.label;
    }); // if there is no tracking of payments for the currently selected booking then initiate it

    if (!BookingModule.bookingsAmountsTrack[String((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.uuid)]) initiateAmountsTracking();
    var paymentSettings = computed(function () {
      // Return only payment settings that are used
      return POSConfigModule.getPaymentSettings.filter(function (setting) {
        return setting.used;
      });
    });

    function selectdefaultPaymentMethod() {
      // We only support Cash with Refund, we don't force the user his default payment method in this case
      if (BookingModule.bookingStep !== BookingStep.Refund) {
        var usedPaymentTool = getDefaultPaymentTool();
        updatePaymentTool(usedPaymentTool.id, usedPaymentTool.name);
      }
    } // Whenever the user resets paymentSettings we need to select a default paymentMethod


    watch(paymentSettings, function () {
      selectdefaultPaymentMethod();
    }, {
      deep: true
    });

    function initiateAmountsTracking() {
      var _BookingModule$select2, _BookingModule$select3;

      var BookingUUID = (_BookingModule$select2 = BookingModule.selectedBooking) === null || _BookingModule$select2 === void 0 ? void 0 : _BookingModule$select2.uuid;
      var usedPaymentTool = POSConfigModule.getPaymentSettings.filter(function (paymentMethod) {
        return paymentMethod.used === true;
      })[0];
      var track = {
        currentAmount: 0,
        currency: ((_BookingModule$select3 = BookingModule.selectedBooking) === null || _BookingModule$select3 === void 0 ? void 0 : _BookingModule$select3.currency) || Currencies.CHF,
        // paymentTool: PaymentTool.CardAuto,
        paymentTool: usedPaymentTool.name,
        paymentToolId: usedPaymentTool.id || null,
        paymentCard: null,
        // paymentCard: PaymentCard.Mastercard,
        confirmedAmounts: []
      };
      BookingModule.addPaymentTracking({
        BookingUUID: BookingUUID,
        track: track
      });
    }

    var selectedBookingUUID = computed(function () {
      var selectedBooking = BookingModule.selectedBooking;

      if (!selectedBooking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }

      var uuid = selectedBooking.uuid;

      if (!uuid) {
        throw new Error(PSBErrors.HasNoUUID);
      }

      return uuid;
    });
    var formattedPaymentCurrency = computed(function () {
      return formatCurrency(BookingModule.selectedBooking.currency);
    });
    var hasEnteredAmount = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].currentAmount;
    });
    var isFullDiscount = computed(function () {
      if (bookingTotalIgnoringDiscounts.value <= discountTotal.value) {
        return true;
      }

      return false;
    });
    var paymentTool = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].paymentTool;
    });
    var paymentCard = computed(function () {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value].paymentCard;
    });
    /**
     * The amount we display for the user to pay
     * For bookings that support split payment it is what is left to pay OR it is what the user enters
     * For normal bookings it is the sum of pss final values, if user enters an amount, then we show it
     */

    var displayedAmount = computed(function () {
      // if (paymentTool.value === PaymentTool.Cash) {
      //   return (
      //     formatCurrency(paymentCurrency.value) +
      //     " " +
      //     hasEnteredAmount.value.toFixed(2)
      //   );
      // }
      if (splitAmountToBePaid.value) {
        return splitAmountText.value;
      } else {
        return whatIsLeftToPayText.value;
      }
    });
    var whatIsLeftToPayText = computed(function () {
      return formatCurrency(paymentCurrency.value) + " " +
      /*Math.abs*/
      (whatIsLeftToPay.value / 100).toFixed(2);
    });
    var whatIsLeftToPay = computed(function () {
      var _selectedCashCurrency2;

      return restToPay.value * (((_selectedCashCurrency2 = selectedCashCurrency.value) === null || _selectedCashCurrency2 === void 0 ? void 0 : _selectedCashCurrency2.exchangeRate) || 1);
    });
    var splitAmountToBePaid = computed(function () {
      var _BookingModule$splitA, _selectedCashCurrency3;

      // we take the value before it was rounded (if it was), because thats what the user supplied
      return (((_BookingModule$splitA = BookingModule.splitAmount) === null || _BookingModule$splitA === void 0 ? void 0 : _BookingModule$splitA.splitAmountProvided) || 0) * (((_selectedCashCurrency3 = selectedCashCurrency.value) === null || _selectedCashCurrency3 === void 0 ? void 0 : _selectedCashCurrency3.exchangeRate) || 1);
    });
    var splitAmountText = computed(function () {
      return formatCurrency(paymentCurrency.value) + " " + splitAmountToBePaid.value.toFixed(2);
    });
    var doesSupportSplitPayment = computed(function () {
      return BookingModule.doesSupportSplitPayment;
    });
    var splitPayments = computed(function () {
      var _BookingModule$select4;

      var paidAmounts = (_BookingModule$select4 = BookingModule.selectedBooking) === null || _BookingModule$select4 === void 0 ? void 0 : _BookingModule$select4.accountings.filter(function (acc) {
        return acc.transactionType === 1 && (acc.state === AccountingState.Completed || acc.state === AccountingState.Pending && !acc.id
        /*making sure it is not coming from backend*/
        && (acc.promocode || acc.promoCodeUuid) || acc.state === AccountingState.Pending && acc.paymentMethod === PaymentMethods.METHOD_POS_CASH);
      }).flat();
      return paidAmounts;
    });
    var payInMultiCurrencies = ref(false);

    function toggleMultiCurrencies() {
      payInMultiCurrencies.value = !payInMultiCurrencies.value;

      if (!payInMultiCurrencies.value) {
        BookingModule.setSelectedCashCurrency(null);
        updateEnteredAmount(Math.abs(restToPay.value) / 100);
      } else {
        var currency = currencies.value.filter(function (c) {
          return c.label !== bookingPaymentCurrency.value;
        })[0];
        BookingModule.setSelectedCashCurrency(currency);
        updateEnteredAmount(Math.abs(restToPay.value) * currency.exchangeRate / 100);
      }
    }

    function selectedCashCurrencyChanged(currencyLabel) {
      var currency = currencies.value.find(function (c) {
        return c.label === currencyLabel;
      }) || null;
      BookingModule.setSelectedCashCurrency(currency);
      updateEnteredAmount(Math.abs(restToPay.value) * ((currency === null || currency === void 0 ? void 0 : currency.exchangeRate) || 1) / 100);
    }

    function updateEnteredAmount(amount) {
      BookingModule.addCurrentAmount({
        BookingUUID: BookingModule.selectedBookingUUID,
        amount: amount
      }); // If we're in a booking that support split payment then we set the splitPaymentAmount here,
      // this split amount will have accountings created based on it, it shouldn't be more than what is left to pay for the booking

      if (BookingModule.doesSupportSplitPayment) {
        var roundedAmount;

        if (selectedCashCurrency.value) {
          // the amount in this case was given in secondary currency and has to be converted
          amount = amount * (1 / (selectedCashCurrency.value.exchangeRate || 1)); // if currency is not CHF we keep roundedAmount = amount for simplicity

          roundedAmount = amount;

          if (selectedBooking.value.currency === Currencies.CHF) {
            roundedAmount = roundToNearestMultipleOf5(Math.round(amount * 100)) / 100;
          }
        }

        BookingModule.setSplitPaymentAmount({
          BookingUUID: BookingModule.selectedBookingUUID,
          splitAmount: roundedAmount || amount
          /*Math.min(
          amount,
          Math.abs(BookingModule.leftToPayAmount / 100)
          )*/
          ,
          splitAmountProvided: amount
        });
      }
    }

    function updatePaymentCurrency(currency) {
      BookingModule.setPaymentCurrency({
        BookingUUID: BookingModule.selectedBookingUUID,
        currency: currency
      });
    }

    function updatePaymentTool(paymentToolId, paymentTool) {
      BookingModule.setPaymentTool({
        BookingUUID: BookingModule.selectedBookingUUID,
        paymentTool: paymentTool,
        paymentToolId: paymentToolId
      }); // isDiscountsDisplayed.value = false;

      var bs = _defineProperty({}, String(BookingModule.selectedBookingUUID), BookingStep.Payment);

      BookingModule.setBookingStep(bs);
    }

    function updatePaymentCard(paymentCard) {
      BookingModule.setPaymentCard({
        BookingUUID: BookingModule.selectedBookingUUID,
        paymentCard: paymentCard
      });
    }

    function showCalculator() {
      ModalModule.setStatus(ModalStatus.PaymentCalculator);
    }

    function disablePaymentTool(paymentOption) {
      // A payment too is disabled when:
      // It is not selected && Booking has confirmedAmounts && Discount is not selected
      // return (
      //   paymentTool.value !== paymentOption &&
      //   BookingModule.bookingsAmountsTrack[BookingModule.selectedBookingUUID]
      //     .confirmedAmounts.length > 0 &&
      //   paymentTool.value !== PaymentTool.Discount
      // );
      // @Hamza: I am disabling only when discount is selected
      // Please check if this is ok cause now with split payment, there is
      // no reason to disable payment methods.
      if (paymentOption === PaymentTool.Discount) {
        return BookingModule.bookingsAmountsTrack[BookingModule.selectedBookingUUID].confirmedAmounts.length > 0;
      }

      return false;
    }

    function displayDiscounts() {
      // First if there is no discount tracking for this booking lets add a discount tracking to this booking with default values
      var d = BookingModule.selectedBookingDiscountTrack;

      if (d) {
        var _bs2 = _defineProperty({}, String(BookingModule.selectedBookingUUID), BookingStep.Discount);

        BookingModule.setBookingStep(_bs2);
        return;
      }

      var selectedBooking = BookingModule.selectedBooking;

      if (!selectedBooking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }

      BookingModule.addDiscountTracking({
        BookingUUID: BookingModule.selectedBookingUUID,
        track: {
          isApplied: false,
          type: DiscountTypes.Percentage_Discount,
          value: 5,
          isOnAllOrder: true,
          pricesIds: _toConsumableArray(new Set(selectedBooking.pssList.map(function (pss) {
            return pss.priceId;
          }))),
          pssDiscounts: [],
          discountTotalValue: 0
        }
      });

      var bs = _defineProperty({}, String(BookingModule.selectedBookingUUID), BookingStep.Discount);

      BookingModule.setBookingStep(bs);
    }

    function displayPromocodeArea() {
      var bs = _defineProperty({}, String(BookingModule.selectedBookingUUID), BookingStep.Promocode);

      BookingModule.setBookingStep(bs);
    }

    var showPromocodeCampaignsButton = computed(function () {
      return POSConfigModule.isVHS || [19657].includes(Number(groupId.value));
    });

    function displayPromocodeCampaigns() {
      var bs = _defineProperty({}, String(BookingModule.selectedBookingUUID), BookingStep.PromocodeCampaigns);

      BookingModule.setBookingStep(bs);
    }

    var selectedBooking = computed(function () {
      var booking = BookingModule.selectedBooking;

      if (!booking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }

      return booking;
    });

    function applyCashPayment() {
      deleteUncompletedBookingAccountings(selectedBooking.value);
      applyPayment();
    }

    var refundPaymentMethodOptions = computed(function () {
      // Return used payment methods
      var refundPaymentMethods = _toConsumableArray(paymentSettings.value); // If there is no payment method left, then we return cash


      if (!refundPaymentMethods.length) {
        refundPaymentMethods.push({
          id: PaymentMethodTypes.Cash,
          name: PaymentMethodTypeToTranslatedString.value[PaymentMethodTypes.Cash]
        });
      } else {
        var cardIndex = refundPaymentMethods.findIndex(function (pm) {
          return pm.id === PaymentMethodTypes.CardAuto;
        });

        if (cardIndex > -1) {
          // Push the Card method to bottom of the list if its disabled
          var element = refundPaymentMethods.splice(cardIndex, 1)[0];
          refundPaymentMethods.push(element);
        }
      }

      return refundPaymentMethods;
    }); // let's set the default payment method also for refund

    var refundPaymentMethod = ref(refundPaymentMethodOptions.value[0].id || PaymentMethodTypes.Cash);
    var pssToRefundList = computed(function () {
      var bookingCopy = cloneDeep(selectedBooking.value); // get the pss we're about to refund

      var cancelledPss = bookingCopy.pssList.filter(function (pss) {
        return pss.bookingStatus === BookingStatus.Canceled;
      });

      if (!cancelledPss || !cancelledPss.length) {
        return [];
      } // Find the ones we need to refund, they are the one that have positive balance


      var cancelledPssUuidString = cancelledPss.map(function (pss) {
        return pss.uuid;
      }).join(" - ");
      var pssToRefundList = BookingModule.pssListBalances.filter(function (pss) {
        return cancelledPssUuidString.includes(String(pss.pssUuid)) && pss.balance > 0;
      }).map(function (pss) {
        return pss.pss;
      });
      return pssToRefundList;
    });

    function proceedAdyenRefund(_x) {
      return _proceedAdyenRefund.apply(this, arguments);
    }
    /**
     * Create Refund accountings for the cancelled PSS with the parameter amount
     * amountInCents is negative
     */


    function _proceedAdyenRefund() {
      _proceedAdyenRefund = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(amountInCents) {
        var bookingCopy, alreadyRefunded, accountingToRefund, _loop3, i, _ret2, bookingId, accountingToRefundId, uid, accountingUuid, bookingInfo, accountingInfo, retries, refundData, _refundResponse$data, _refundResponse$data2, _refundResponse$data3, refundResponse, pulledAccountings, remoteAccountings, newAdyenAccounting, newAccountings, message, keyword, parts;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                alreadyRefunded = function _alreadyRefunded(splitReference) {
                  var refundAndPaymentAccountings = bookingCopy.accountings.filter(function (acc) {
                    return acc.paymentMethod === PaymentMethods.METHOD_POS_ADYEN && (acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND || acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT) && acc.state === AccountingState.Completed && acc.splitReference === splitReference;
                  }).map(function (ac) {
                    return ac.accountingEntriesList;
                  }).flat().map(function (ae) {
                    return ae.value;
                  });
                  var refundAndPaymentSum = sumArray(refundAndPaymentAccountings);
                  return refundAndPaymentSum <= 0;
                };

                bookingCopy = cloneDeep(selectedBooking.value); // checks if an accounting is already refunded by calculating the differnce between payments and refunds

                _loop3 = function _loop3(i) {
                  var pssToRefund = pssToRefundList.value[i];
                  accountingToRefund = bookingCopy.accountings.find(function (acc) {
                    return acc.paymentMethod === PaymentMethods.METHOD_POS_ADYEN && acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT && acc.splitReference && !alreadyRefunded(acc.splitReference) && acc.accountingEntriesList.some(function (ae) {
                      return ae.productSlotStateUuid === pssToRefund.uuid;
                    });
                  });

                  if (accountingToRefund) {
                    // one accounting at a time
                    return "break";
                  }
                };

                i = 0;

              case 4:
                if (!(i < pssToRefundList.value.length)) {
                  _context.next = 11;
                  break;
                }

                _ret2 = _loop3(i);

                if (!(_ret2 === "break")) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("break", 11);

              case 8:
                i++;
                _context.next = 4;
                break;

              case 11:
                if (accountingToRefund) {
                  _context.next = 14;
                  break;
                }

                LogService.info("No adyen payment accounting to refund was found");
                return _context.abrupt("return");

              case 14:
                bookingId = bookingCopy.id;
                accountingToRefundId = accountingToRefund.id;

                if (!(!bookingId || !accountingToRefundId)) {
                  _context.next = 54;
                  break;
                }

                _context.prev = 17;
                AppModule.updatedIsLoading(true);
                uid = bookingCopy.uuid;
                accountingUuid = accountingToRefund.uuid;

                if (uid) {
                  _context.next = 23;
                  break;
                }

                throw new Error(PSBErrors.HasNoUUID);

              case 23:
                if (accountingUuid) {
                  _context.next = 25;
                  break;
                }

                throw new Error(ACCErrors.HasNoUUID);

              case 25:
                retries = 0;

              case 26:
                if (!((!bookingInfo || !accountingInfo) && retries < 5)) {
                  _context.next = 39;
                  break;
                }

                _context.next = 29;
                return getBookingWithUUID(uid);

              case 29:
                bookingInfo = _context.sent;
                _context.next = 32;
                return getAccountingWithUUID(accountingUuid);

              case 32:
                accountingInfo = _context.sent;
                LogService.info("Booking with uuid: ".concat(uid, " or accounting with uuid: ").concat(accountingUuid, " were not found when refunding by card, retrying in 3000ms"));
                retries++;
                _context.next = 37;
                return Timeout.set(3000);

              case 37:
                _context.next = 26;
                break;

              case 39:
                if (!(!bookingInfo || !accountingInfo)) {
                  _context.next = 43;
                  break;
                }

                // synching failed
                LogService.info("Booking with uuid: ".concat(uid, " or accounting with uuid: ").concat(accountingUuid, " were not found when refunding by card, stopped retrying"));
                NotificationService.showGeneralResponseError();
                return _context.abrupt("return");

              case 43:
                bookingId = bookingInfo.id || undefined;
                accountingToRefundId = accountingInfo.id || undefined;
                _context.next = 51;
                break;

              case 47:
                _context.prev = 47;
                _context.t0 = _context["catch"](17);
                LogService.info("Error occured when fetching booking/accounting info: ".concat(selectedBooking.value.uuid), {
                  error: _context.t0
                });
                NotificationService.showGeneralResponseError();

              case 51:
                _context.prev = 51;
                AppModule.updatedIsLoading(false);
                return _context.finish(51);

              case 54:
                refundData = {
                  bookingId: bookingId,
                  amount: amountInCents / 100 * -1,
                  paymentMethod: accountingToRefund.paymentMethod,
                  accounting: accountingToRefundId,
                  channel: "SMEETZ POS"
                };
                LogService.info("starting refund with Adyen: ".concat(selectedBooking.value.uuid, " with amount ").concat(amountInCents / 100, ", payload attached"), {
                  refundData: refundData
                });
                AppModule.updatedIsLoading(true);
                _context.prev = 57;
                _context.next = 60;
                return postPOSRefund(refundData);

              case 60:
                refundResponse = _context.sent;

                if (!(!((_refundResponse$data = refundResponse.data) !== null && _refundResponse$data !== void 0 && _refundResponse$data.productSlotStates) || !((_refundResponse$data2 = refundResponse.data) !== null && _refundResponse$data2 !== void 0 && (_refundResponse$data3 = _refundResponse$data2.bookingRecap) !== null && _refundResponse$data3 !== void 0 && _refundResponse$data3.accounting))) {
                  _context.next = 64;
                  break;
                }

                LogService.info("Unexpected response received when refunding with Adyen: ".concat(selectedBooking.value.uuid, " with amount ").concat(amountInCents / 100), {
                  refundData: refundData,
                  response: refundResponse
                });
                throw new Error("Unexpected adyen refund response");

              case 64:
                LogService.info("Accounting successfully refunded with adyen with amount ".concat(amountInCents / 100, ", going to update booking"), {
                  refundData: refundData,
                  response: refundResponse
                }); // get the newly created accountings from backend

                _context.next = 67;
                return getBookingAccountings(String(bookingId));

              case 67:
                pulledAccountings = _context.sent;

                if (pulledAccountings) {
                  _context.next = 72;
                  break;
                }

                LogService.info("No accountings were pulled from backend for booking with uuid: ".concat(bookingCopy.uuid));
                NotificationService.showGeneralResponseError();
                return _context.abrupt("return");

              case 72:
                remoteAccountings = toLocalAccountings(bookingCopy.uuid, pulledAccountings); // refund accounting

                newAdyenAccounting = remoteAccountings.find(function (remoteAcc) {
                  return !bookingCopy.accountings.some(function (localAcc) {
                    return localAcc.uuid === remoteAcc.uuid;
                  });
                }); // add the new refund accounting and update the current booking

                newAccountings = bookingCopy.accountings.concat(newAdyenAccounting);
                BookingModule.updateBookingAccountings({
                  bookingUUID: bookingCopy.uuid || "",
                  accountings: newAccountings
                });

                if (newAdyenAccounting.state === AccountingState.Failed) {
                  message = newAdyenAccounting.message;
                  keyword = "FAILED_REFUND >>";
                  parts = (message === null || message === void 0 ? void 0 : message.split(keyword)) || []; // Check if the keyword exists and there is content after it

                  if (parts.length > 1) {
                    NotificationService.showCustomMessage(parts[1].trim(), "warning");
                  } else {
                    // Default message if the keyword is not present
                    NotificationService.showCustomMessage(String(t("payment-service.unknown")), "warning");
                  }
                }

                _context.next = 83;
                break;

              case 79:
                _context.prev = 79;
                _context.t1 = _context["catch"](57);
                LogService.info("Error occured when refunding with Adyen: ".concat(selectedBooking.value.uuid, " with amount ").concat(amountInCents / 100), {
                  refundData: refundData,
                  error: _context.t1
                });
                NotificationService.showGeneralResponseError();

              case 83:
                _context.prev = 83;
                AppModule.updatedIsLoading(false);
                return _context.finish(83);

              case 86:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[17, 47, 51, 54], [57, 79, 83, 86]]);
      }));
      return _proceedAdyenRefund.apply(this, arguments);
    }

    function proceedRegularRefund(amountInCents) {
      var bookingCopy = cloneDeep(selectedBooking.value);
      var refundPaymentTool = PaymentMethodTypeToPaymentTool[refundPaymentMethod.value]; // create TICKET accounting

      var ticketTypeAccounting = createRefundPSSAccounting(amountInCents, PaymentToolMethod[refundPaymentTool]);
      ticketTypeAccounting.forEach(function (acc) {
        return bookingCopy.accountings.push(acc);
      }); // lests add refund info to the pss

      var pssUuidsList = ticketTypeAccounting.map(function (acc) {
        return acc.accountingEntriesList;
      }).flat().map(function (ae) {
        return ae.productSlotStateUuid;
      });
      var refundedPssList = bookingCopy.pssList.filter(function (pss) {
        return pssUuidsList.includes(pss.uuid);
      });

      for (var i = 0; i < refundedPssList.length; i++) {
        refundedPssList[i].refundedAt = dayjs().toISOString();
        refundedPssList[i].refundAmount = getPSSValue(refundedPssList[i]); // because we fully refund a pss

        refundedPssList[i].refundStatus = RefundStatus.Completed;
      } //update cashfloat: extract refund amount from total cashfloat
      // const previousCashFloatAmount = CashFloatModule.cashFloat?.amount || 0;
      // const dateNow = dayjs().toISOString();
      // const updatedAmount = previousCashFloatAmount - Math.abs(amountInCents);
      // //update amount field of Cash float in db and state
      // CashFloatModule.setCashFloat(
      //   Object.assign({}, CashFloatModule.cashFloat, {
      //     updatedAt: dateNow,
      //     amount: updatedAmount,
      //   })
      // );


      BookingModule.updateBooking(bookingCopy);
    }
    /**
     * Call appropriate refund function depending on payment method
     * amountInCents is negative
     */


    function handleRefund(amountInCents) {
      LogService.info("Proceeding refund for booking: ".concat(selectedBooking.value.uuid, " with amount ").concat(amountInCents / 100, " paymentMethod: ").concat(refundPaymentMethod.value), {
        params: {
          booking: selectedBooking.value
        }
      });

      switch (refundPaymentMethod.value) {
        case PaymentMethodTypes.CardAuto:
          proceedAdyenRefund(amountInCents);
          break;

        default:
          proceedRegularRefund(amountInCents);
          break;
      }
    }

    var isPromocodeApplied = computed(function () {
      return BookingModule.isPromocodeApplied;
    });
    var showDiscountButton = computed(function () {
      // Hide discount button for Chillon (L2-1009)
      if (POSConfigModule.groupId === 16268) {
        return false;
      }

      return true;
    });

    function isRefundPaymentMethodDisabled(paymentSetting) {
      if (paymentSetting.id === PaymentMethodTypes.CardAuto) {
        var _POSConfigModule$sele;

        // check config setting
        if (!((_POSConfigModule$sele = POSConfigModule.selectedConfig) !== null && _POSConfigModule$sele !== void 0 && _POSConfigModule$sele.isRefundActivated)) {
          return true;
        } // check if cancelled pss are linked to accountings not paid using Adyen


        var bookingCopy = cloneDeep(selectedBooking.value);

        var _loop2 = function _loop2(i) {
          var pssToRefund = pssToRefundList.value[i]; // find discount and payment accounting linked to the refunded pss

          var pssAccounting = bookingCopy.accountings.find(function (acc) {
            return (acc.transactionType === TransactionTypes.TRANSACTION_TYPE_DISCOUNT || acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT) && acc.accountingEntriesList.some(function (ae) {
              return ae.productSlotStateUuid === pssToRefund.uuid && acc.paymentMethod !== PaymentMethods.METHOD_POS_ADYEN;
            });
          });

          if (pssAccounting) {
            // all accountings we're about to refund must be adyen payments, so we disable it
            return {
              v: true
            };
          }
        };

        for (var i = 0; i < pssToRefundList.value.length; i++) {
          var _ret = _loop2(i);

          if (_typeof(_ret) === "object") return _ret.v;
        }
      }

      return false;
    }

    return {
      t: t,
      paymentTool: paymentTool,
      paymentCard: paymentCard,
      hasEnteredAmount: hasEnteredAmount,
      isFullDiscount: isFullDiscount,
      whatIsLeftToPay: whatIsLeftToPay,
      displayedAmount: displayedAmount,
      // total,
      formattedPaymentCurrency: formattedPaymentCurrency,
      // bookingTotal,
      PaymentTool: PaymentTool,
      PaymentCard: PaymentCard,
      showDiscount: showDiscount,
      paymentCurrency: paymentCurrency,
      // showCashButton,
      step: step,
      BookingStep: BookingStep,
      updatePaymentCurrency: updatePaymentCurrency,
      updateEnteredAmount: updateEnteredAmount,
      updatePaymentTool: updatePaymentTool,
      updatePaymentCard: updatePaymentCard,
      applyCashPayment: applyCashPayment,
      showCalculator: showCalculator,
      disablePaymentTool: disablePaymentTool,
      Currencies: Currencies,
      paymentConfig: paymentConfig,
      displayDiscounts: displayDiscounts,
      displayPromocodeArea: displayPromocodeArea,
      iconContent: iconContent,
      iconAlt: iconAlt,
      iconStyle: iconStyle,
      cashPaymentMethod: cashPaymentMethod,
      cardAutoPaymentMethod: cardAutoPaymentMethod,
      cardManualPaymentMethod: cardManualPaymentMethod,
      bankTransferPaymentMethod: bankTransferPaymentMethod,
      InvoicePaymentMethod: InvoicePaymentMethod,
      isFree1: isFree1,
      isFullyPaidInPromocodeStep: isFullyPaidInPromocodeStep,
      isFullyPaidInDiscountStep: isFullyPaidInDiscountStep,
      canCompleteOrder: canCompleteOrder,
      selectedBooking: selectedBooking,
      groupId: groupId,
      getLocale: getLocale,
      doesSupportSplitPayment: doesSupportSplitPayment,
      whatIsLeftToPayText: whatIsLeftToPayText,
      IsEditOrder: IsEditOrder,
      ChequePaymentMethod: ChequePaymentMethod,
      ChequeVacancesPaymentMethod: ChequeVacancesPaymentMethod,
      handleRefund: handleRefund,
      paymentSettings: paymentSettings,
      PaymentMethodTypeToPaymentTool: PaymentMethodTypeToPaymentTool,
      PaymentMethodTypeToTranslatedString: PaymentMethodTypeToTranslatedString,
      CEPaymentMethod: CEPaymentMethod,
      OCCYGPaymentMethod: OCCYGPaymentMethod,
      selectdefaultPaymentMethod: selectdefaultPaymentMethod,
      refundPaymentMethod: refundPaymentMethod,
      refundPaymentMethodOptions: refundPaymentMethodOptions,
      PaymentMethodTypes: PaymentMethodTypes,
      isPromocodeApplied: isPromocodeApplied,
      currencies: currencies,
      selectedCashCurrency: selectedCashCurrency,
      groupCurrency: groupCurrency,
      selectedCashCurrencyChanged: selectedCashCurrencyChanged,
      selectedCashCurrencyLabel: selectedCashCurrencyLabel,
      toggleMultiCurrencies: toggleMultiCurrencies,
      payInMultiCurrencies: payInMultiCurrencies,
      bookingPaymentCurrency: bookingPaymentCurrency,
      restToPay: restToPay,
      hasMultiCurrenciesEnabled: hasMultiCurrenciesEnabled,
      showDiscountButton: showDiscountButton,
      displayPromocodeCampaigns: displayPromocodeCampaigns,
      showPromocodeCampaignsButton: showPromocodeCampaignsButton,
      isRefundPaymentMethodDisabled: isRefundPaymentMethodDisabled
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var isBookingCoveredByAvailabilities, bookingAvailabilityInfo, noAvailabilityInfo;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return syncAvailabilities([_this.selectedBooking]);

            case 2:
              _context2.next = 4;
              return BookingModule.updateBookingAvailabilityInfo();

            case 4:
              // check if the new availabilities are all enough for the booking in progress ... Do it thru getters
              isBookingCoveredByAvailabilities = BookingModule.isBookingCoveredByAvailabilities; // ignore availabilities if an Adyen payment is in progress to avoid removing pss while processing the payment

              if (!(!PaymentService.serviceId && !isBookingCoveredByAvailabilities)) {
                _context2.next = 11;
                break;
              }

              // get the booking availabilities info
              bookingAvailabilityInfo = BookingModule.bookingAvailabilityInfo;
              noAvailabilityInfo = bookingAvailabilityInfo === null || bookingAvailabilityInfo === void 0 ? void 0 : bookingAvailabilityInfo.filter(function (info) {
                return info.bookedQty > info.dbAvailability;
              });

              if (!(!noAvailabilityInfo || !noAvailabilityInfo.length)) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return");

            case 10:
              // Show the user a popup informing him that the category X price Y booked quantity will be removed because there is no enough quantity
              ModalModule.setStatus(ModalStatus.AvailabilityInfo);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var leftToPay;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this2.selectdefaultPaymentMethod();

              window.SingleCategoryEvent = SingleCategoryEvent;
              leftToPay = restToPay.value;

              _this2.updateEnteredAmount(Math.abs(leftToPay) / 100);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  beforeUnmount: function beforeUnmount() {
    this.updateEnteredAmount(0);
    BookingModule.setSelectedCashCurrency(null);
  },
  methods: {}
});